module.exports = __webpack_public_path__ + "static/media/tools-all-clear.db7bd04b.svg";